import request from '@/utils/request'

// 查询产品标签树
export function getTypeTree() {
    return request({
        url: '/profile/product/type/treeData',
        method: 'get'
    })
}
